const UPDATE_TYPES = {
  general: "GENERAL",
  requirement: "REQUIREMENT",
  doc: "DOC",
  user: "USER",
  VERIFICATION_PREFERENCE: "VERIFICATION_PREFERENCE",
};

const USER_TYPES = {
  FACILITY_USER: "Facility User",
  SIGNATORY: "Signatory",
  facility: "FACILITY",
};

const ACTIONS = {
  added: "ADDED",
  removed: "REMOVED",
  updated: "UPDATED",
};

export { ACTIONS, UPDATE_TYPES, USER_TYPES };
